var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import SystemSettingsService from '../../api/SystemSettingsService';
import VueDialog from "../../interface/IVueDialog";
import ClientService from "../../api/ClientService";
import { setTreeDisable } from "../../helper/util";
import RegexStr from "../../common/RegexStr";
var phoneRegex = new RegExp(RegexStr.mobile);
var ShopDialog = (function (_super) {
    __extends(ShopDialog, _super);
    function ShopDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.categoryList = [];
        _this.formData = null;
        _this.groups = [];
        _this.systemSetting = '';
        _this.logistic = [];
        _this.routes = [];
        _this.cleaningCompanyList = [];
        _this.financeTaxationList = [];
        _this.brandList = [];
        return _this;
    }
    ShopDialog.prototype.created = function () {
        this.service = ClientService.getInstance();
        this.systemSettingsService = SystemSettingsService.getInstance();
        this.formData = {
            shop_name: this.shop.shop_name,
            shop_code: this.shop.shop_code,
            shop_contact: this.shop.shop_contact,
            shop_phone: this.shop.shop_phone,
            business_name: this.shop.business_name,
            shop_area: this.shop.shop_city_id || null,
            shop_address: this.shop.shop_address,
            route_name: this.shop.route_name,
            comment: this.shop.note,
            shop_agent_id: this.shop.shop_agent_id,
            logisticName: this.shop.logistics ? this.shop.logistics.split('、') : '',
            logistics_sort: this.shop.logistics_sort || null,
            cleaning_company_id: this.shop.cleaning_company_id != 0 ? this.shop.cleaning_company_id : null,
            finance_taxation_id: this.shop.finance_taxation_id != 0 ? this.shop.finance_taxation_id : null,
            shop_brand_id: this.shop.shop_brand_id != 0 ? this.shop.shop_brand_id : null
        };
    };
    ShopDialog.prototype.handleLogisticsSort = function () {
        var sort = this.formData.logistics_sort;
        if (sort !== '' && sort !== null && sort !== undefined) {
            sort = /^\d+$/.test(sort) ? sort : '';
            sort = sort.length > 1 ? sort.replace(/^0+/, '') : sort;
            sort = sort.length > 3 ? sort.slice(0, 3) : sort;
            this.formData.logistics_sort = sort;
        }
    };
    ShopDialog.prototype.onlyNumbers = function (event) {
        var key = event.key;
        if (key !== 'Backspace' && !/\d/.test(key)) {
            event.preventDefault();
        }
    };
    ShopDialog.prototype.close = function () {
        this.$closeDialog();
    };
    ShopDialog.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    ShopDialog.prototype.mounted = function () {
        var _this = this;
        this.service.getArea().then(function (res) {
            var data = res.data;
            if (data.success) {
                setTreeDisable(data.data);
                _this.categoryList = data.data[0].children;
            }
            else {
                _this.$message.error(data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        this.getSupplierConfigdetail();
        this.getLogistic();
        this.getRoute();
    };
    Object.defineProperty(ShopDialog.prototype, "shouldShowThirdPartyFields", {
        get: function () {
            var isSortingEnabled = this.systemSetting && this.systemSetting.edi_status == 1;
            var isNotFromSupplyChain = this.clientDetail && this.clientDetail.from_system != 1;
            return isSortingEnabled && isNotFromSupplyChain;
        },
        enumerable: true,
        configurable: true
    });
    ShopDialog.prototype.loadThirdPartyOptions = function () {
        var _this = this;
        this.service.getThirdPartyOptions().then(function (res) {
            if (res.data && res.data.success) {
                var data = res.data.data || {};
                _this.cleaningCompanyList = data.cleaning_company_list || [];
                _this.financeTaxationList = data.finance_taxation_list || [];
                _this.brandList = data.brand_list || [];
            }
        }).catch(function (err) {
            console.error('加载第三方分拣系统选项失败:', err);
        });
    };
    ShopDialog.prototype.change = function () {
        console.log(333);
    };
    ShopDialog.prototype.getLogistic = function () {
        var _this = this;
        var params = {
            business_id: this.shop.business_id
        };
        this.service.getLogistic(params).then(function (res) {
            _this.logistic = Array.isArray(res.data.data) ? res.data.data : [];
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    ShopDialog.prototype.getRoute = function () {
        var _this = this;
        this.service.getRoute({ limit: 9999 }).then(function (res) {
            _this.routes = Array.isArray(res.data.data) ? res.data.data : [];
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    ShopDialog.prototype.getSupplierConfigdetail = function () {
        var _this = this;
        this.systemSettingsService.getSupplierConfigdetail({}).then(function (res) {
            if (res.data && res.data.success) {
                _this.systemSetting = res.data.data;
                if (_this.shouldShowThirdPartyFields) {
                    _this.loadThirdPartyOptions();
                }
            }
        });
    };
    ShopDialog.prototype.save = function () {
        var _this = this;
        var formData = this.formData;
        if (formData.shop_name == '') {
            this.$message.error('请填写门店名称');
            return;
        }
        ;
        if (formData.shop_area == null || formData.shop_area == 0) {
            this.$message.error('请选择所在区域');
            return;
        }
        ;
        if (formData.shop_address == '') {
            this.$message.error('请填写门店地址');
            return;
        }
        ;
        var routeRegex = /[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g;
        if (formData.route_name != '' && routeRegex.test(formData.route_name)) {
            this.$message.error('分拣路线格式不正确！');
            return;
        }
        var rankRegex = /^(?:[1-9]\d{0,2}|0)$/;
        if (formData.logistics_sort && !rankRegex.test(formData.logistics_sort)) {
            this.$message.error('配送排序格式不正确！');
            return;
        }
        var params = {
            supplier_to_shop_id: this.shop.supplier_to_shop_id,
            shop_name: this.formData.shop_name,
            shop_code: this.formData.shop_code,
            shop_contact: this.formData.shop_contact,
            shop_phone: this.formData.shop_phone,
            shop_address: this.formData.shop_address,
            shop_city_id: this.formData.shop_area,
            note: this.formData.comment,
            shop_agent_id: this.formData.shop_agent_id,
            logistics: this.formData.logisticName,
            logistics_sort: this.formData.logistics_sort,
            route_id: '',
            route_name: '',
            cleaning_company_id: this.formData.cleaning_company_id || 0,
            finance_taxation_id: this.formData.finance_taxation_id || 0,
            shop_brand_id: this.formData.shop_brand_id || 0
        };
        var idx = this.routes.findIndex(function (item) { return item.route_name == formData.route_name; });
        if (idx !== -1) {
            params.route_id = this.routes[idx].route_id;
        }
        else {
            params.route_name = this.formData.route_name;
        }
        this.service.editSupplierShop(params).then(function (res) {
            if (res.data.success) {
                _this.$message.success('保存成功！');
                _this.close();
                _this.$emit('editShopInfo:ok');
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            window._czc.push(["_trackEvent", '供货门店列表', '编辑门店']);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    ShopDialog = __decorate([
        Component
    ], ShopDialog);
    return ShopDialog;
}(VueDialog));
export default ShopDialog;
